import {cloneObjectArray} from '../../helpers'
import lpOffers from '../../api/offer'

export default {
  state: {
    lpOffers: [],
    lpOffersOrigin: [],
  },
  namespaced: true,
  mutations: {
    async saveLpOffers(state, lpOffers) {
      state.lpOffers = lpOffers
      state.lpOffersOrigin = cloneObjectArray(lpOffers)
    },
    async addLpOffers(state, offerId) {

      const getLastId = (sf) => {
        let loadMin = null
        for (const item of sf) {
          if (!loadMin || item.id > loadMin.id) {
            loadMin = item
          }
        }
        return loadMin.id
      }

      let lastId = state.lpOffers.length !== 0 && getLastId(state.lpOffers) || 0

      let lp = {}
      lp.name = ''
      lp.url = ''
      lp.offerId = offerId
      lp.id = lastId + 1

      state.lpOffers.push(lp)
    },
    fastAddLpOffers(state, data) {

      const getLastId = (sf) => {
        let loadMin = null
        for (const item of sf) {
          if (!loadMin || item.id > loadMin.id) {
            loadMin = item
          }
        }
        return loadMin.id
      }

      let lastId = state.lpOffers.length !== 0 && getLastId(state.lpOffers) || 0

      let lp = {}
      lp.name = data.url || ''
      lp.url = data.url || ''
      lp.offerId = data.offerId
      lp.id = lastId + 1

      state.lpOffers.push(lp)
    },
    async updLpOffers(state, data) {
      let lps = state.lpOffers.map(item => {
        if (item.id === data.id) {
          item[data.field] = data.value
        }
        return item
      })
      state.lpOffers = lps

    },
    async delLpOffers(state, id) {

      state.lpOffers = state.lpOffers
        .filter(item => (item.id !== id))
    },
    preSaveLpOffer(state) {
      state.lpOffersOrigin = cloneObjectArray(state.lpOffers)
    },
    cancelLpOffer(state) {
      state.lpOffers = cloneObjectArray(state.lpOffersOrigin)
    },
    saveCurrentState(state){
      state.lpOffersOrigin = cloneObjectArray(state.lpOffers)
    }
  },
  actions: {
    async saveLpOffersStore({commit}, id) {
      commit('saveLpOffers', await lpOffers.lpOffers(id))
    },
    async saveCurrentLpState({commit}) {
      commit('saveCurrentState')
    },
    async getLp({commit}, id) {
      return await lpOffers.lpOffers(id)
    },
  },
  getters: {
    getLpOffers: state => state.lpOffers,
    getLpOffersOrigin: state => state.lpOffersOrigin,
  },

}
